import { createPortal } from 'react-dom';
import { IAccordion } from './interfaces';

export const SchemaJsonQuestion = ({ questions }: { questions: IAccordion[] }) => {
  return questions.length
    ? createPortal(
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "FAQPage",
              "mainEntity": [${questions.map(({ title, content }) => {
                let textFix = '';
                if (content) {
                  textFix = content.replaceAll('\n', '').replaceAll('\r', '').replaceAll('"', '\\"');
                }
                return `{
                  "@type": "Question",
                  "name": "${title}",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "${textFix}"
                  }
                }`;
              })}]
            }`,
          }}
        ></script>,
        document.head
      )
    : null;
};
